import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import { useMessagesStore } from '@/stores/messages'

export const useWebCategoryStore = defineStore('webCategory', {
  state: () => ({
    webCategory: {
      id: null,
      title: '',
      slug: '',
      system_record: false,
      enabled: true,
      list_order: 0,
    }
  }),

  actions: {
    async fetch({ webCategoryId }) {
      return httpClient.get(`/api/internal/web_categories/${webCategoryId}`)
        .then(({ data: { web_category } }) => {
          this.webCategory = web_category
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
        })
    },

    async save() {
      return this.webCategory.id ? this.update() : this.create()
    },

    async create() {
      const { webCategory } = this

      return httpClient.post('/api/internal/web_categories', { web_category: webCategory })
        .then(({ data: { web_category } }) => {
          this.webCategory = web_category
          useMessagesStore().addNotice('Web category created')
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
          throw err
        })
    },

    async update() {
      const { webCategory } = this

      return httpClient.patch(`/api/internal/web_categories/${webCategory.id}`, { web_category: webCategory })
        .then(({ data: { web_category } }) => {
          this.webCategory = web_category
          useMessagesStore().addNotice('Web category saved')
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
          throw err
        })
    },

    async destroy() {
      const { id } = this.webCategory

      return httpClient.delete(`/api/internal/web_categories/${id}`)
        .then(() => {
          this.$reset()
          useMessagesStore().addNotice('Web category deleted')
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
        })
    },
  }
})
